import TOGGLE_ACTIVATE from '@/store/modules/develop/types';

export default {
  activate: ({ commit }) => commit(TOGGLE_ACTIVATE)
};
